module.exports = __webpack_public_path__ + "img/nishio-takumi@720w.a8ba4b02.png";